import React, { useEffect, useRef, useState } from 'react';

import { REGISTRATION_EMBEDS } from '@nerdwallet/js-auth-tools/dist/registration';
import { Button, Title, Text } from '@nerdwallet/currency';
import classes from '@nerdwallet/base-styles/classes';

import { trackImpression } from '../../lib/analytics-helpers';
import { HOMEPAGE as analyticsBase } from '../../lib/analytics-constants';
import { openAuthDialog } from '../../lib/helpers';

const HomePageReg = () => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [showHomePageReg, setShowHomePageReg] = useState(true);
  const screenRef = useRef();

  const dashboardUrl = '/home/dashboard/home';

  useEffect(() => {
    /* this logic mimics how isLoggedIn is set in Compass
     * https://github.com/NerdWallet/compass/blob/7b1da4ad15d04a71b913d5b34c7deec3c31ed2b5/src/global-nav/fetch-async-props.js#L122
     * We are checking it this way in order to support global-markup and Compass as possible nav sources
     */
    const isLoggedIn = document?.cookie?.includes(
      'member_identity_assertion_token='
    );

    const openRegisterAuthDialogHelper = () => {
      openAuthDialog({
        authType: 'register',
        trk: analyticsBase.trk,
        regTrackingAttributes: {
          cohort: analyticsBase.cohort,
        },
        segmentTrackingAttributes: {
          ...analyticsBase.segmentTrackingAttributes,
          driverElement: 'link',
        },
        onCleanUp: () => {
          setIsUserLoggedIn(true);
          setShowHomePageReg(false);
        },
        onSuccessActions: dashboardUrl,
      });
    };

    const authEmbedProps = {
      authType: 'register',
      el: screenRef.current,
      flow: 'no-security-question',
      flowConfig: {
        openRegisterAuthDialog: openRegisterAuthDialogHelper,
      },
      onSuccess() {
        trackImpression({
          entityName: analyticsBase.entity_names.success,
          sectionName: analyticsBase.section_name,
          registrationCohort: analyticsBase.cohort,
        });
        setIsUserLoggedIn(true);
      },
      onFailure() {
        trackImpression({
          entityName: analyticsBase.entity_names.error,
          registrationCohort: analyticsBase.cohort,
          sectionName: analyticsBase.section_name,
        });
      },
      regFlow: REGISTRATION_EMBEDS.HOME_PAGE_EMBED,
      regTrackingAttributes: {
        entityNames: {
          authButtons: analyticsBase.entity_names.auth_buttons,
        },
        sectionName: analyticsBase.section_name,
        cohort: analyticsBase.cohort,
        additionalAttributes: analyticsBase.additional_attributes,
      },
      segmentTrackingAttributes: {
        ...analyticsBase.segmentTrackingAttributes,
        driverElement: 'button',
      },
      trk: analyticsBase.trk,
      version: 2,
    };

    if (!isLoggedIn) {
      authEmbedProps.onSuccess = dashboardUrl;
    }

    window.nwapi?.ui?.showAuthEmbed(authEmbedProps);
  }, []);

  const renderHomePageReg = () => {
    if (!showHomePageReg) {
      return null;
    }

    return <div ref={screenRef} />;
  };

  const renderMyNerdwalletButton = () => {
    if (!isUserLoggedIn) {
      return null;
    }

    const title = `Get even more financial clarity \nwith a NerdWallet account`;
    const subtitle = `See all your savings, credit cards, and investments together in one place. With everything connected, you'll get timely nerdy insights so you can be sure you're making the right financial decisions for you. Best of all, it's free.`;

    return (
      <React.Fragment>
        <div className="text">
          <Title size="small" component="h2">
            {title}
          </Title>
          <div className="subtitle">
            <Text>{subtitle}</Text>
          </div>
          <div className="subtitle-mobile">
            <Text>{subtitle}</Text>
          </div>
        </div>
        <div className={classes('margin-vertical-4')}>
          <div className={classes('display-none', 'display-block--wide')}>
            <Button secondary href={dashboardUrl}>
              Go to My NerdWallet
            </Button>
          </div>
          <div className={classes('display-block', 'display-none--wide')}>
            <Button secondary block href={dashboardUrl}>
              Go to My NerdWallet
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  };

  return (
    <div>
      {renderHomePageReg()}
      {renderMyNerdwalletButton()}
    </div>
  );
};

export default HomePageReg;
